//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
} from "../../../helpers/fakebackend_helper";

import {
  loginSuccess,
  logoutUserSuccess,
  apiError,
  reset_login_flag,
} from "./reducer";
import { Axios } from "api/axios";
import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINT } from "helpers/Endpoints/endpoints";

export const loginUser = (user: any, history: any) => async (dispatch: any) => {
  try {
    const userPayload = {
      email: user?.email,
      password: user?.password,
      remember_me: user?.remember_me || false,
    };

    const userLogin = await Axios.post(
      API_ENDPOINT.AUTH.LOGIN,
      JSON.stringify(userPayload),
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    if (userLogin.status === 200 && userLogin?.data) {
      const userPayload = userLogin.data; // ✅ clean object
      // console.log("User login data: line 36", userPayload);

      localStorage.setItem("authUser", JSON.stringify(userPayload.data));
      dispatch(loginSuccess(userPayload)); // ✅ pass clean object
      return userPayload;
    } else {
      dispatch(apiError("Login failed. Please check your credentials."));
      return Promise.reject("Login failed");
    }
  } catch (error: any) {
    // console.log("LOGIN ERROR",)
    const resData = error?.response?.data;

    let backendMsg = "Login failed. Please check try again later.";
    if (resData && typeof resData === "object") {
      backendMsg =
        resData.error || resData.message || resData.detail || backendMsg;

      dispatch(apiError(backendMsg));
      return Promise.reject(backendMsg);
    }
  }
};

export const logoutUser = () => async (dispatch: any) => {
  try {
    localStorage.removeItem("authUser");
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      let fireBaseBackend = getFirebaseBackend();
      const response = fireBaseBackend.logout;
      dispatch(logoutUserSuccess(response));
    } else {
      dispatch(logoutUserSuccess(true));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const socialLogin =
  (type: any, history: any) => async (dispatch: any) => {
    try {
      let response;

      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const fireBaseBackend = getFirebaseBackend();
        response = fireBaseBackend.socialLoginUser(type);
      }
      //  else {
      //   response = postSocialLogin(data);
      // }

      const socialdata = await response;
      if (socialdata) {
        localStorage.setItem("authUser", JSON.stringify(socialdata));
        dispatch(loginSuccess(socialdata));
        history("/dashboard");
      }
    } catch (error) {
      dispatch(apiError(error));
    }
  };

export const resetLoginFlag = () => async (dispatch: any) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const fetchUserDetails = createAsyncThunk(
  "Login/fetchUserDetails",
  async (_, { getState }) => {
    const state: any = getState();

    const userId = state.Login.user?.user_id; // Adjust if your user object uses a different key

    if (!userId) throw new Error("User ID not found in state");
    const response = await Axios.get(
      API_ENDPOINT.USER_MANAGEMENT.USER.DETAIL(userId)
    );

    return response.data;
  }
);

export const fetchLatestPermissions = createAsyncThunk(
  "Login/fetchLatestPermissions",
  async (_, { getState, rejectWithValue }) => {
    try {
      const state: any = getState();

      const userId =
        state.Login.user?.user_id ||
        JSON.parse(localStorage?.getItem("authUser") as string)?.user_id;

      // console.log("authUser : ",JSON.parse(localStorage?.getItem('authUser') as string)?.user_id)

      if (!userId) {
        return rejectWithValue("User ID not found in state");
      }

      const res = await Axios.get(
        API_ENDPOINT.USER_MANAGEMENT.USER.GET_USER_PERMISSION(userId)
      );

       console.log(
          "res.data.data:: ", res.data.data
        );


      // Extract permissions from response structure: { data: { permissions: [...] } }
      const permissions = res.data?.data?.permissions || res.data?.permissions || [];

      if (permissions && permissions.length > 0) {
       
        localStorage.setItem(
          "userPermissions",
          JSON.stringify(permissions)
        );
      }

      if(res.data.data.user_type) {
        let authUser = JSON.parse(localStorage.getItem("authUser") as string);
        authUser.user_type = res.data.data.user_type;
        localStorage.setItem("authUser", JSON.stringify(authUser));
      }

      return permissions;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch latest permissions"
      );
    }
  }
);

export const fetchLatestPermissionsLogin = createAsyncThunk(
  "Login/fetchLatestPermissions",
  async (userId: string, { getState, rejectWithValue }) => {
    try {
      const res = await Axios.get(
        API_ENDPOINT.USER_MANAGEMENT.USER.DETAIL(userId)
      );

      if (res.data.permissions) {
        // localStorage.setItem("userPermissions", JSON.stringify(res.data.permissions));
      }

      return res.data.permissions;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch latest permissions"
      );
    }
  }
);

export const sendForgotPasswordOTP =
  (email: string) => async (dispatch: any) => {
    try {
      const res = await Axios.post("/users/forgot-password/", { email });

      if (res.data.success) {
        return Promise.resolve(res.data);
      }

      return Promise.reject(res.data.message);
    } catch (error: any) {
      const message =
        error?.response?.data?.message || "Failed to send OTP";
      dispatch(apiError(message));
      return Promise.reject(message);
    }
  };

/* STEP 2: Verify OTP */
export const verifyForgotPasswordOTP =
  (email: string, otp: string) => async (dispatch: any) => {
    try {
      const res = await Axios.post("/users/verify-otp/", {
        email,
        otp,
      });

      if (res.data.success) {
        return Promise.resolve(res.data);
      }

      return Promise.reject(res.data.message);
    } catch (error: any) {
      const message =
        error?.response?.data?.message || "Invalid OTP";
      dispatch(apiError(message));
      return Promise.reject(message);
    }
  };

/* STEP 3: Reset Password */
export const resetForgotPassword =
  (email: string, newPassword: string) => async (dispatch: any) => {
    try {
      const res = await Axios.post("/users/reset-password/", {
        email,
        new_password: newPassword,
      });

      if (res.data.success) {
        return Promise.resolve(res.data);
      }

      return Promise.reject(res.data.message);
    } catch (error: any) {
      const message =
        error?.response?.data?.message || "Failed to reset password";
      dispatch(apiError(message));
      return Promise.reject(message);
    }
  };
